import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { CurrentLocationBaseDto, ServiceProtocolStatus } from 'api';

import { OfflineActivitiesType, ServiceInfoStepStateType } from '../Types';
import { GenerateServiceProtocolSlice } from './Types';

export const initialState: GenerateServiceProtocolSlice = {
	serviceProtocolId: null,
	drivelineId: 0,
	activeStep: 0,
	isOnline: true,
	isEmob: false,
	location: {} as CurrentLocationBaseDto,
	offlineActivities: {
		additionalComment: '',
		serviceName: '',
	},
	serviceInfo: {} as ServiceInfoStepStateType,
	status: null,
};

export const generateServiceProtocolSlice = createSlice({
	name: 'generateServiceProtocol',
	initialState,
	reducers: {
		nextStep: (state) => {
			state.activeStep += 1;
		},
		previousStep: (state) => {
			if (state.activeStep === 0) {
				return;
			}

			state.activeStep -= 1;
		},
		reset: () => initialState,
		setId: (state, { payload }: PayloadAction<number>) => {
			state.serviceProtocolId = payload;
		},
		serviceProtocolPageLoaded: (
			state,
			{
				payload,
			}: PayloadAction<{
				drivelineId: number;
				serviceProtocolId: number | null | undefined;
			}>
		) => {
			state.drivelineId = payload.drivelineId;

			if (payload.serviceProtocolId != null) {
				state.serviceProtocolId = payload.serviceProtocolId;
			}
		},
		setIsOnline: (state, { payload }: PayloadAction<boolean>) => {
			state.isOnline = payload;
		},
		setIsEmob: (state, { payload }: PayloadAction<boolean>) => {
			state.isEmob = payload;
		},
		setLocation: (
			state,
			{ payload }: PayloadAction<CurrentLocationBaseDto>
		) => {
			state.location = payload;
		},
		setOfflineActivities: (
			state,
			{ payload }: PayloadAction<OfflineActivitiesType>
		) => {
			state.offlineActivities = payload;
		},
		setServiceInfo: (
			state,
			{ payload }: PayloadAction<ServiceInfoStepStateType>
		) => {
			state.serviceInfo = payload;
		},
		setStatus: (
			state,
			{ payload }: PayloadAction<ServiceProtocolStatus | null>
		) => {
			state.status = payload;
		},
		setStep: (state, { payload }: PayloadAction<number>) => {
			state.activeStep = payload;
		},
	},
});

export const {
	actions: {
		nextStep,
		previousStep,
		reset,
		setId,
		serviceProtocolPageLoaded,
		setIsOnline,
		setIsEmob,
		setLocation,
		setOfflineActivities,
		setServiceInfo,
		setStatus,
		setStep,
	},
} = generateServiceProtocolSlice;

export default generateServiceProtocolSlice.reducer;
